<template>
    <div class="about">
        <b-modal
            v-model="showDeleteTemplateModal"
            title="Delete"
            v-on:ok='deleteTemplate()'
            size='md'
            centered
        >
            This will delete the template '{{delTemplate.name}}'permanently. Are you sure?
        </b-modal>

        <b-modal
            v-model="showShareTemplateModal"
            title="Share"
            v-on:ok='doShareTemplate()'
            size='md'
            centered
        >
            <div class="form-row">
                <b-input-group>
                    <b-form-input 
                        v-model="shareEmail" 
                        placeholder="email..."
                        :state=shareUserState 
                        class="form-control" />
                </b-input-group>
                Please enter an email address to share the  template '{{shareTemplate.name}}' with.
            </div>
        </b-modal>

        <b-alert
            :show=alertCountDown
            dismissible
            @dismissed = "alertCountDown=0"
            @dismiss-count-down= "countDownChanged"
            fade
            >
            Shared template "{{sharedTemplateName}}"
        </b-alert>


        <div class="table-area">
            <div class=table-responsive-sm>
                <b-table 
                    bordered
                    :per-page='perPage'
                    :currentPage='currentPage'
                    :items="templates"
                    :fields="templateFields"
                    striped
                    >

                    <template v-slot:cell(name)='data'>
                        <b-link :to="{name:'template', params:{id:data.item.id}}">{{data.item.name}}</b-link>
                    </template>

                    <template v-slot:cell(action)='data'>
                        <b-row>
                            <b-col md='auto'>
                                <font-awesome-icon 
                                    :icon="['fas', 'trash-alt']"
                                    @click="startDeleteTemplate(data.item)">
                                </font-awesome-icon>
                            </b-col>
                            <b-col md='auto'>
                                <font-awesome-icon 
                                    :icon="['fas', 'share-alt']"
                                    @click="startShareTemplate(data.item)">
                                </font-awesome-icon>
                            </b-col>
                        </b-row>
                    </template>
                </b-table>
                <b-pagination
                    v-model='currentPage'
                    :totalRows='templates.length'
                    :per-page='perPage'>
                </b-pagination>
            </div>

        </div>
    </div>
    
</template>

<script>
import { mapState } from 'vuex'

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

export default {
    data(){
        return {
            alertCountDown: 0,
            currentPage: 1,
            perPage: 10,
            showDeleteTemplateModal: false,
            showShareTemplateModal: false,
            delTemplate: {},
            shareTemplate: {},
            shareEmail: null,
            sharedTemplateName: "",
            templateFields: [
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'desc',
                    label: 'Description',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }

            ]
        }
    },
    methods: {
        startDeleteTemplate(item) {
            this.delTemplate = item
            this.showDeleteTemplateModal = true
        },
        deleteTemplate() {
            console.log("deleting", this.delTemplate)
            this.$store.dispatch('templates/delete', this.delTemplate)
        },
        startShareTemplate(item) {
            this.shareTemplate = item
            this.showShareTemplateModal = true
        },
        doShareTemplate() {
            console.log("sharing", this.shareTemplate, this.shareEmail)

            let newOwner = this.lookupUser(this.shareEmail)
            if(newOwner) {
                this.$store.dispatch('templates/share', {template:this.shareTemplate, newOwner})

                this.sharedTemplateName = this.shareTemplate.name
                this.alertCountDown = 5
            }
            this.shareTemplate = {}
            this.shareEmail = null

        },
        countDownChanged: function(dismissCountDown) {
            this.alertCountDown = dismissCountDown
        },
        lookupUser(email) {
            let users = this.users
            let u = users.find(u => u.email == email)
            return u ? u.owner : undefined
        }
    },
    computed: {
        ...mapState({
            templates: state => state.templates.all,
            users: state => state.users.all
        }),
        shareUserState() {
            return this.shareEmail && validateEmail(this.shareEmail) &&
                (this.lookupUser(this.shareEmail) != null)
        }

    },

    async beforeCreate() {
        this.$store.dispatch('templates/load')
        this.$store.dispatch('users/load')
    }
}
</script>

<style scoped>

</style>